import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import request from '../../utils/request';

const SimpleAdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    console.log('=== 管理员登录开始 ===');
    console.log('用户名:', username);
    
    try {
      console.log('发送登录请求到: /admin/login (通过统一baseURL)');
      
      const data = await request.post('/admin/login', {
        username,
        password,
      });
      
      console.log('响应数据:', data);
      
      if (data.success) {
        console.log('登录成功！');
        
        localStorage.setItem('admin_token', data.data.access_token);
        localStorage.setItem('admin_user', JSON.stringify(data.data.user));
        
        console.log('Token已保存，准备跳转...');
        
        // 直接跳转
        window.location.href = '/admin/dashboard';
      } else {
        console.error('登录失败:', data.message);
        alert('登录失败: ' + (data.message || '未知错误'));
      }
    } catch (error) {
      console.error('登录错误:', error);
      const msg = error?.response?.data?.detail || error?.message || '未知错误';
      alert('登录失败: ' + msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#1890ff' }}>
          管理员登录
        </h2>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>用户名:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                fontSize: '14px'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px' }}>密码:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                fontSize: '14px'
              }}
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#1890ff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '16px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1
            }}
          >
            {loading ? '登录中...' : '登录'}
          </button>
        </form>
        
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'none',
              border: 'none',
              color: '#1890ff',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            返回用户端
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimpleAdminLogin;